import {useContext} from "react";
import AuthorizationContext from "../context/AuthorizationContext"

const useAuthorization = () => {
    return useContext(AuthorizationContext)
}

export default useAuthorization